import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-white" data-id="element-1369">
      {/* Decorative Background Blobs — very subtle on white */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-1370" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tl from-brand-purple/[0.08] to-brand-coral/[0.05] rounded-full blur-3xl translate-x-1/3 translate-y-1/3 animate-float-delayed pointer-events-none" data-id="element-1371" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1372">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-y-8 lg:gap-y-12 gap-x-12 lg:gap-x-20 lg:items-center" data-id="element-1373">
          {/* Eyebrow badge + Title */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-1 lg:col-start-1 lg:row-start-1 max-w-2xl flex flex-col items-center text-center lg:items-center" data-id="element-1374">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-gold/40 bg-white/60 backdrop-blur-sm mb-6 shadow-sm" data-id="element-1375">
              <span className="font-heading font-bold text-xs md:text-sm tracking-[0.15em] text-brand-gold uppercase" data-id="element-1376">
                Dezvoltare Personală și Spirituală
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-[64px] leading-[1.1] font-bold text-brand-text text-balance" data-id="element-1377">
              De la blocaje interioare și stres, la abundență și liniște în
              viață
            </h1>
          </motion.div>

          {/* Image Area */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-2 lg:order-2 lg:col-start-2 lg:row-start-1 lg:row-span-2 relative w-full aspect-[3/4] max-w-[420px] mx-auto lg:ml-auto" data-id="element-1378">
            {/* Decorative Glow Behind Image */}
            <div className="absolute inset-0 bg-brand-gold/30 rounded-[32px] blur-2xl transform translate-x-4 translate-y-4" data-id="element-1379" />

            {/* WOW ELEMENTS */}
            {/* Thin gold arc/semicircle top-right */}
            <div className="absolute -top-12 -right-12 w-48 h-48 border-[1.5px] border-brand-gold/40 rounded-full border-b-transparent border-l-transparent rotate-45 -z-10" data-id="element-1380" />

            {/* Cluster of 3 small gold diamonds top-left */}
            <div className="absolute -top-6 -left-4 flex flex-col gap-2" data-id="element-1381">
              <div className="w-3 h-3 bg-brand-gold/60 rotate-45" data-id="element-1382" />
              <div className="w-2 h-2 bg-brand-gold/40 rotate-45 ml-4" data-id="element-1383" />
              <div className="w-1.5 h-1.5 bg-brand-gold/80 rotate-45 ml-1" data-id="element-1384" />
            </div>

            {/* Subtle concentric circles bottom-left */}
            <div className="absolute -bottom-16 -left-16 w-32 h-32 border border-brand-gold/20 rounded-full -z-10" data-id="element-1385" />
            <div className="absolute -bottom-12 -left-12 w-24 h-24 border border-brand-gold/30 rounded-full -z-10" data-id="element-1386" />
            <div className="absolute -bottom-8 -left-8 w-16 h-16 border border-brand-gold/40 rounded-full -z-10" data-id="element-1387" />

            {/* Soft purple-to-gold gradient orb bottom-right */}
            <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-gradient-to-tr from-brand-purple/30 to-brand-gold/30 rounded-full blur-xl -z-10" data-id="element-1388" />

            {/* Thin horizontal gold line with dots near top */}
            <div className="absolute top-8 -right-20 w-20 h-px bg-brand-gold/40 flex items-center justify-between" data-id="element-1389">
              <div className="w-1 h-1 bg-brand-gold rounded-full" data-id="element-1390" />
              <div className="w-1 h-1 bg-brand-gold rounded-full" data-id="element-1391" />
            </div>

            {/* Main Image Container */}
            <div className="relative w-full h-full rounded-[32px] shadow-warm overflow-hidden border-4 border-white" data-id="element-1392">
              <img src="https://cdn.magicpatterns.com/uploads/1rkWgruLABLbiu4kcbCtdt/73.png" alt="Adrian Huniade" className="w-full h-full object-cover object-top" data-id="element-1393" />
            </div>
          </motion.div>

          {/* Subtitle + CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-3 lg:order-3 lg:col-start-1 lg:row-start-2 max-w-2xl flex flex-col items-center text-center" data-id="element-1394">
            <p className="font-subtitle font-medium text-lg md:text-xl text-brand-textSec mb-10 leading-relaxed text-balance" data-id="element-1395">
              Un proces pas cu pas pentru oameni care simt că viața lor poate fi
              mai bună, dar nu știu de unde să înceapă. Te ghidez să identifici
              credințele care te țin pe loc, să le transformi și să creezi o
              viață plină de armonie, prosperitate și pace interioară.
            </p>

            <div className="flex flex-col items-center gap-4 w-full" data-id="element-1396">
              <a href="https://academiadeabundenta.ro/sesiune-cadou" target="_top" className="inline-block bg-brand-gold text-brand-cream font-heading font-semibold text-lg px-9 py-5 rounded-xl hover:bg-brand-purple transition-colors duration-300 shadow-warm hover:shadow-warm-hover w-full sm:w-auto text-center" data-id="element-1397">
                Rezervă Sesiunea Cadou
              </a>
              <p className="font-subtitle italic text-lg text-brand-textSec max-w-md" data-id="element-1398">
                Dacă ai încercat multe și simți că tot ești în același loc, nu e
                despre voință. E despre o ghidare potrivită și practică reală.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}